<template>
  <div>
    <svg viewBox="0 0 160 200">
      <circle :cx="cx" :cy="cy" :r="radius" fill="transparent" :stroke="colors[0]" :stroke-width="width" />
      <g v-for="(value, index) in dataProccesed" :key="index">
        <circle
          :cx="cx"
          :cy="cy"
          :r="radius"
          fill="transparent"
          :stroke="colors[index + 1]"
          :stroke-width="width"
          :stroke-dasharray="circumference"
          :stroke-dashoffset="calculateStrokeDashOffset(value, circumference)"
          :transform="returnCircleTransformValue(index)"
        />
        <text
          class="category-percentage"
          v-if="segmentBigEnough(value)"
          text-anchor="middle"
          dy="3px"
          :x="chartData[index].textX"
          :y="chartData[index].textY"
          :fill="backColors[index + 1]"
        >
          {{ value }}
        </text>
      </g>
      <g>
        <text class="percentage-number" :x="cx" :y="cy - 10" dominant-baseline="middle" text-anchor="middle">
          {{ dataTotal }}
        </text>
        <text class="percentage-text" :x="cx" :y="cy + 12" dominant-baseline="middle" text-anchor="middle">
          {{ $t('local_vs_away.total') }}
        </text>
      </g>
      <g v-if="showLabels">
        <g
          class="item-play-hover"
          :class="getPlayingAs && getPlayingAs !== 1 ? 'disabled-label' : ''"
          @click="setOpenMedia(1, dataTotal)"
        >
          <rect x="24" y="160" width="60" height="18" :fill="colors[1]" rx="4" />
          <text
            x="49"
            s
            y="170"
            class="category-text"
            :fill="backColors[1]"
            dominant-baseline="middle"
            text-anchor="middle"
          >
            {{ translatedCategories[0] }}
          </text>
          <image
            :class="dataTotal == 0 ? 'disable-img' : ''"
            x="30"
            y="164"
            width="80"
            height="10"
            href="https://golstatsimages.blob.core.windows.net/todoelfut/icn_playsvg.svg"
          />
        </g>

        <g
          class="item-play-hover"
          :class="getPlayingAs && getPlayingAs !== 2 ? 'disabled-label' : ''"
          @click="setOpenMedia(2, dataTotal)"
        >
          <rect x="88" y="160" width="62" height="18" :fill="colors[2]" rx="4" />
          <text
            x="113"
            y="170"
            class="category-text"
            :fill="backColors[2]"
            dominant-baseline="middle"
            text-anchor="middle"
          >
            {{ translatedCategories[1] }}
          </text>
          <image
            :class="dataTotal == 0 ? 'disable-img' : ''"
            x="100"
            y="164"
            width="80"
            height="10"
            href="https://golstatsimages.blob.core.windows.net/todoelfut/icn_playsvg.svg"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
export default {
  name: 'PassesCircleBar',
  props: {
    category: {
      type: Object,
      defautl: () => {},
    },
    data: {
      type: Array,
      required: true,
    },
    categoryIds: {
      type: Array,
      default: () => [],
    },
    colors: {
      type: Array,
      required: false,
      default: function() {
        return ['#e3e3e4', '#0060ff', '#9013fe'];
      },
    },
    backColors: {
      type: Array,
      required: false,
      default: function() {
        return ['#000000', '#ffffff', '#ffffff'];
      },
    },
    categories: {
      type: Array,
      required: false,
      default: function() {
        return ['local_vs_away.local', 'local_vs_away.away'];
      },
    },
    startAngle: {
      type: Number,
      required: false,
      default: function() {
        return Math.random() * 360;
      },
    },
    width: {
      type: Number,
      required: false,
      default: 20,
    },
    showLabels: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      cx: 80,
      cy: 80,
      radius: 60,
    };
  },
  computed: {
    ...mapGetters({ getGamesPlayedByTeam: 'filterGeneral/getGamesPlayedByTeam' }),
    ...mapGetters('filterGeneral', {
      getGamesPlayedByTeam: 'getGamesPlayedByTeam',
      getResults: 'getResults',
      getSections: 'getSections',
      getPlayingAs: 'getPlayingAs',
      getSelectedGamesIds: 'getSelectedGamesIds',
      seasonSelected: 'getSeasonId',
    }),
    ...mapGetters('teamsGeneral', {
      teamId: 'teamId',
    }),
    ...mapState('filterGeneral', ['tournamentsForMediaPlayer']),
    gamesPlayed() {
      return this.getGamesPlayedByTeam === 0 ? 1 : this.getGamesPlayedByTeam;
    },
    dataProccesed() {
      return this.data.map(d => +(d / this.gamesPlayed).toFixed(2));
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    dataTotal() {
      return +this.dataProccesed.reduce((acc, val) => acc + val, 0).toFixed(2);
    },
    effectiveness() {
      return Math.floor(((this.dataProccesed[0] + this.dataProccesed[1]) * 100) / this.dataTotal) || 0;
    },
    chartData() {
      let angleOffset = this.startAngle;
      return this.dataProccesed.reduce((a, v) => {
        const { x, y } = this.calculateTextCoords(v, angleOffset);
        a.push({ degrees: angleOffset, textX: x, textY: y });
        angleOffset = (v / this.dataTotal) * 360 + angleOffset;
        return a;
      }, []);
    },
    translatedCategories() {
      return this.categories.map(categoryTranslateKey => {
        return this.$t(categoryTranslateKey);
      });
    },
  },
  methods: {
    ...mapMutations('mediaModal', ['setModalInitialState', 'setIsModalOpen']),
    setOpenMedia(playingAs, value) {
      const singleName = this.getSingleName(this.$t(this.category.translationKey));
      if (value !== 0) {
        let jsonConfig = {
          seasonId: this.seasonSelected,
          tournaments: this.tournamentsForMediaPlayer,
          categoryIds: this.categoryIds,
          categorySingleName: singleName,
          mainSectionType: 1,
          playListType: 3,
          gameIds: this.getSelectedGamesIds,
          teamId: this.teamId,
          playerIds: [],
          matchResult: this.getResults,
          playData: {},
          advancedFilter: {
            playListTitle: `${this.$t(this.category.translationKey)} (${playingAs === 1 ? 'local' : 'visitante'})`,
            mainCategoryId: {},
            playingAs: [playingAs],
            timeSections: this.getSections,
            fieldSections: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
          },
          stringMediaPlayerTitle: 'Resumen de equipo',
        };
        this.setModalInitialState(jsonConfig);
        this.setIsModalOpen(true);
      }
    },
    getSingleName(categoryName) {
      const categoryNameArray = categoryName.split(' ');
      return categoryNameArray
        .reduce((accumulator, word) => {
          let wordAux = word;
          if (word.endsWith('lones')) {
            wordAux = word.replace('lones', 'lón');
          } else if (word.endsWith('oles')) {
            wordAux = word.replace('oles', 'ol');
          } else if (word.endsWith('os') || word.endsWith('as') || word.endsWith('es')) {
            wordAux = word.slice(0, word.length - 1);
          }
          accumulator.push(wordAux);
          return accumulator;
        }, [])
        .join(' ');
    },
    calculateStrokeDashOffset(dataVal, circumference) {
      const strokeDiff = (dataVal / this.dataTotal) * circumference;
      return circumference - strokeDiff;
    },
    returnCircleTransformValue(index) {
      return `rotate(${this.chartData[index].degrees || 0}, ${this.cx}, ${this.cy})`;
    },
    degreesToRadians(angle) {
      return angle * (Math.PI / 180);
    },
    calculateTextCoords(dataVal, angleOffset) {
      const angle = ((dataVal / this.dataTotal) * 360) / 2 + angleOffset;
      const radians = this.degreesToRadians(angle);

      return {
        x: this.radius * Math.cos(radians) + this.cx,
        y: this.radius * Math.sin(radians) + this.cy,
      };
    },
    percentageLabel(dataVal) {
      return `${Math.round((dataVal / this.dataTotal) * 100)}%`;
    },
    segmentBigEnough(dataVal) {
      return Math.round(this.dataPercentage(dataVal) * 100) > 5;
    },
    dataPercentage(dataVal) {
      return dataVal / this.dataTotal;
    },
  },
};
</script>

<style scoped>
.disable-img {
  opacity: 0.6;
}
.disabled-label {
  opacity: 0.2;
  pointer-events: none;
}
.percentage-number {
  font-family: 'Avenir-Demi';
  font-size: 22px;
  fill: #808285;
}
.percentage-text {
  font-family: 'Avenir-Demi';
  font-size: 10px;
  fill: #808285;
}
.category-text {
  font-family: 'Avenir-Demi';
  font-size: 8px;
}
.item-play-hover:hover {
  opacity: 0.8;
  cursor: pointer;
}

.category-percentage {
  font-family: 'Avenir-Bold';
  font-size: 8px;
}
</style>
